export const toPixels = (length) => {
  let conversionFactor = 96;
  conversionFactor /= 25.4;

  return conversionFactor * length + 'px';
};

export const toMillimiter = (pixels) => {
  let conversionFactor = 96;
  conversionFactor /= 25.4;

  return pixels / conversionFactor;
};
